<template>
    <th class="py-4 px-8">
        <slot></slot>
    </th>
</template>
